// removed by extract-text-webpack-plugin
module.exports = {"placeholderGray":"#9297A3","borderGray":"#D3D6DC","fields":"fields-3_T-B","field":"field-1j4j3","abbr":"abbr-2dVgL","spacer":"spacer-1I4UO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/DurationField/_durationField.css
// module id = 1190
// module chunks = 1